<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import { dateFormatYear } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal";
import { dateFormat } from "@/utils/helpers/format";
import medicionSeveridadAPI from "../../../services/standards/medicionSeveridad/medicionSeveridadAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import MedicionSeveridadPagination from "../../../components/standard/medicionSeveridad/MedicionSeveridadPagination.vue";

/**
 * Form elements component
 */
export default {
  page: {
    title: "3.3.1 Medición de la severidad de la accidentalidad",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    CheckModal,
    Layout,
    Style,
    PageHeader,
    MedicionSeveridadPagination,
  },
  data() {
    return {
      title: "3.3.1 Medición de la severidad de la accidentalidad",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Medición",
          active: true,
        },
      ],

      itemData: null,
      item: null,
      search: "",
      itemStatus: "No cumplido",
      loading: true,
      submitted: false,
      years: [],
      lista: [],

      meses: [
        {
          id: 1,
          name: "Enero",
        },
        {
          id: 2,
          name: "Febrero",
        },
        {
          id: 3,
          name: "Marzo",
        },
        {
          id: 4,
          name: "Abril",
        },
        {
          id: 5,
          name: "Mayo",
        },
        {
          id: 6,
          name: "Junio",
        },
        {
          id: 7,
          name: "Julio",
        },
        {
          id: 8,
          name: "Agosto",
        },
        {
          id: 9,
          name: "Septiembre",
        },
        {
          id: 10,
          name: "Octubre",
        },
        {
          id: 11,
          name: "Noviembre",
        },
        {
          id: 12,
          name: "Diciembre",
        },
      ],

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      numero: null,
      numero2: null,
      medicion: {
        annual_goal: this.numero2,
        monthly_goal: this.numero,
        annual_period: 1,
        year: null,
        people_know_result: null,
        responsible_measurement: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
    };
  },
  methods: {
    validarNumero() {
      if (this.numero <= 0) {
        this.numero = 0;
      } else if (this.numero > 100) {
        this.numero = 100;
      }
      if (this.numero !== null) {
        const numeroString = this.numero.toString().substring(0, 3);
        this.numero = parseInt(numeroString);
      }
      this.medicion.monthly_goal = this.numero
    },
    validarNumero2() {
      if (this.numero2 <= 0) {
        this.numero2 = 0;
      } else if (this.numero2 > 100) {
        this.numero2 = 100;
      }
      if (this.numero2 !== null) {
        const numeroString = this.numero2.toString().substring(0, 3);
        this.numero2 = parseInt(numeroString);
      }
      this.medicion.annual_goal = this.numero2
    },
    validarTecla(event) {
      const keyCode = event.keyCode || event.which;
      if (
        (keyCode >= 48 && keyCode <= 57) || // Números del teclado alfanumérico
        (keyCode >= 96 && keyCode <= 105) || // Números del teclado numérico
        keyCode === 8 // Tecla de retroceso
      ) {
        // Permitir la tecla
      } else {
        // Prevenir la tecla si no es válida
        event.preventDefault();
      }
    },

    fetch() {
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(35)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 35)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
          if (this.itemStatus === 'No aplica') {
            this.itemStatus = 'No cumplido';
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 35,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            style: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            style: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    save() {
      this.submitted = true
      this.loading = true
      medicionSeveridadAPI
        .save(this.medicion)
        .then((response) => {
          const itemChange = {
            companies_id: this.companyID,
            item_id: 35,
            status: 'Pendiente',
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "¡Éxito!",
                  text: "¡Se ha registrado con éxito!",
                  type: "success",
                  icon: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      medicionSeveridadAPI
        .get(this.companyID)
        .then((response) => {
          this.lista = response.data.data;
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    dateConvert(date) {
      return dateFormat(date);
    },
    dateConvert2(date) {
      return dateFormatYear(date);
    },

    deleteR(id) {
      medicionSeveridadAPI.delete(id)
        .then((response) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 35,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => { })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
          setTimeout(() => {
            Swal.fire({
              title: "Éxito!",
              text: "Informacion eliminada con éxito!",
              type: "success",
              icon: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            window.location.reload();
          }, 2000);

        })
        .catch((error) => {
          console.log(error);
        });
    },

    rangeYear() {
      const max = 2040;
      const min = 2019;
      for (let i = min; i <= max; i++) {
        this.years.push(i);
      }
      return this.years;
    },

    goPage(page) {
      window.location.href = page;
    },
  },

  mounted() {
    this.rangeYear();
    this.getList();
    this.getItems();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12 m-0 p-0" v-if="!loading">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <CheckModal>
                  <p class="text-justify">
                    Este indicador mide la cantidad de días perdidos por concepto de accidentes laborales,
                    relacionandolos días de incapacidad y los días cargados por los accidentes mortales o con pérdida de
                    la capacidad laboral.
                  </p>
                  <p class="text-justify">
                    El responsable de la implementación deberá definir la meta mensual y anual, además el responsable de
                    la medición y las personas que deben conocer el resultado.
                  </p>
                  <p class="text-justify">
                    En este ítem podrá encontrar la ficha del indicador de severidad de la accidentalidad, además
                    visualizar el cálculo de este en un periodo determinado.
                  </p>
                </CheckModal>
              </div>

              <div class="form-row col-md-6 col-sm-12 pt-1">
                <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                  <b-form-select v-on:change="changeItemStatus(itemStatus)"
                    :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                    class="selectpicker form-control" v-model="itemStatus">
                    <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                    <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                    <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </div>

              <div class="col-md-6 text-right m-b-0"></div>

              <div class="col-md-6 text-right m-b-0 mt-1">
                <button @click="
                  goPage(
                    `/forms/estandares/${companyID}/medicion-severidad-grafica`
                  )
                  " class="btn btn-primary mx-1">
                  <span class="btn-label"> </span> Generar reporte
                </button>
              </div>
            </div>

            <hr />

            <form class="form-group" @submit.prevent="save">
              <div class="table-responsive px-4 mt-2" v-if="getRole('Consultar')">
                <table class="table-sm pt-2 table border-bottom divide-y divide-gray-200 table-bordered rounded">
                  <thead class="bg-primary text-light">
                    <tr>
                      <th class="text-center align-middle" colspan="4">
                        Ficha técnica del indicador
                      </th>
                    </tr>
                    <tr>
                      <th class="text-center align-middle">Nombre indicador</th>
                      <th class="text-center align-middle" colspan="3">
                        Severidad de la accidentalidad
                      </th>
                    </tr>
                  </thead>
                  <tbody class="">
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Fórmula</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        ((Días perdidos en accidentes de trabajo en un mes +
                        número de días cargados en el mes)/ total de
                        trabajadores activos ese mes) x 100
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Interpretación del indicador</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        Por cada 100 trabajadores que laboran en el mes, se
                        perdieron X días en accidentes de trabajo.
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Meta</b>
                      </td>
                      <td class="text-center align-middle">
                        <b-form-input class="col-md-4" type="text" id="date_exam" v-model="numero"
                          @keydown="validarTecla" @input="validarNumero" maxlength="3">
                        </b-form-input>
                      </td>

                      <td class="text-center align-middle">
                        <b-form-input class="col-md-4" type="text" id="date_exam" v-model="numero2"
                          @keydown="validarTecla" @input="validarNumero2" maxlength="3">
                        </b-form-input>
                      </td>
                      <td class="text-center align-middle">
                        <select required class="col-md-8 form-control" v-model="medicion.year">
                          <b-form-select-option v-for="item in years" :value="item">
                            {{ item }}
                          </b-form-select-option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Periodicidad</b>
                      </td>
                      <td class="text-center align-middle" colspan="1">
                        Mensual
                      </td>

                      <td class="text-center align-middle" colspan="1">
                        Anual
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Fuente de la información</b>
                      </td>
                      <td class="align-middle" colspan="3">
                        <p>Número de trabajadores en el mes</p>
                        <P>Número de accidentes de trabajo en el mes</P>
                        <p>
                          Días de incapacidad en el mes por accidentes de
                          trabajo
                        </p>
                        <p>Días cargados</p>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Personas que deben conocer el resultado</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        <b-form-input type="text" id="date_exam" maxlength="200" v-model="medicion.people_know_result">
                        </b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Responsable de la medición </b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        <b-form-input type="text" id="date_exam" maxlength="200"
                          v-model="medicion.responsible_measurement">
                        </b-form-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="form-group text-right m-b-0 mt-3">
                  <button @click="" :disabled="submitted" type="submit" name="boton" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1">
                    Cancelar
                  </button>
                </div>
              </div>

              <hr v-if="getRole('Consultar')" />

              <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="row pb-3">
                      <div class="col-6">
                        <form @submit.prevent="fetch()" class="form-inline">
                          <div class="form-group mr-2">
                            <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                              class="form-control px-2" placeholder="Buscar"></b-form-input>

                            <div class="col-1">
                              <button type="submit" class="btn btn-primary px-2">
                                Buscar
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="col-6"></div>
                    </div>

                    <div class="table-responsive">
                      <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                        <thead>
                          <tr>
                            <th class="text-center align-middle">Fecha</th>
                            <th class="text-center align-middle">Año</th>
                            <th class="text-center align-middle">
                              Meta mensual
                            </th>
                            <th class="text-center align-middle">Meta anual</th>
                            <th class="text-center align-middle">
                              Personas que deben conocer el resultado
                            </th>
                            <th class="text-center align-middle">
                              Responsable de la medición
                            </th>
                            <th class="text-center align-middle">Acciones</th>
                          </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                          <tr v-for="dato in lista" :key="dato.id">
                            <td class="text-center align-middle">
                              {{ dateConvert(dato.created_at) }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.year }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.monthly_goal }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.annual_goal }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.people_know_result }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.responsible_measurement }}
                            </td>

                            <td class="text-center align-middle">
                              <div class="col-sm-12">
                                <b-dropdown variant="primary">
                                  <template v-slot:button-content>
                                    <i class="mdi mdi-eye"></i>
                                  </template>
                                  <b-dropdown-item :to="{
                                    path: `/forms/estandares/medicion-severidad-ver/${dato.id}`,
                                  }">
                                    Ver</b-dropdown-item>
                                  <b-dropdown-item @click="deleteR(dato.id)">
                                    Eliminar
                                  </b-dropdown-item>
                                </b-dropdown>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <MedicionSeveridadPagination ref="paginator" :search="search"
                        @fetch="(items) => (lista = items)" />
                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
            </form>
          </div>
        </div>
      </div>
      <div v-else class="col-xl-12 text-center">
        <div class="text-center">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
